import React from "react";
import { createIcon } from "@chakra-ui/icon";

export const IOSShareIcon = createIcon({
  displayName: "IOSShareIcon",
  viewBox: "0 0 50 50",
  path: [
    <path d="M30.3 13.7L25 8.4l-5.3 5.3-1.4-1.4L25 5.6l6.7 6.7z" key="1" />,
    <path d="M24 7h2v21h-2z" key="2" />,
    <path d="M35 40H15c-1.7 0-3-1.3-3-3V19c0-1.7 1.3-3 3-3h7v2h-7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h20c.6 0 1-.4 1-1V19c0-.6-.4-1-1-1h-7v-2h7c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3z" key="3" />,
  ],
});

export const FireFoxA2HSIcon = createIcon({
  displayName: "FireFoxA2HSIcon",
  viewBox: "0 0 700 700",
  path: (
    <g transform="translate(0,700) scale(0.1,-0.1)" key="1">
      <path d="M3341 6328 c-29 -8 -266 -235 -614 -585..." />
      <path d="M3403 4280 c-66 -40 -67 -49 -73 -421 -4..." />
    </g>
  ),
});

export const MenuIcon = createIcon({
  displayName: "MenuIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm0 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
      fill="currentColor"
      fillOpacity=".8"
      key="1"
    />
  ),
});

export const OperaA2HSIcon = createIcon({
  displayName: "OperaA2HSIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4zm2 .51A.51.51 0 0 1 7.51 4h8.98a.51.51 0 0 1 .51.51v13.98a.51.51 0 0 1-.51.51H7.51a.51.51 0 0 1-.51-.51V4.51zM10.5 20a.5.5 0 1 0 0 1h3a.5.5 0 1 0 0-1h-3z"
      fill="currentColor"
      fillOpacity=".8"
      key="1"
    />
  ),
});
